import { ConfidentialityConfiguration } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../translations';

import { ConfidentialityUpdateAction } from './ConfidentialityEditModal.actions';
import { ConfidentialityEditForm } from './ConfidentialityEditForm';

const t = generalSettingsTranslationKeys.confidentialitySettings;

type ConfidentialityEditModalProps = {
   confidentialityConfiguration: ConfidentialityConfiguration;
   onClose: VoidFunction;
};

export const ConfidentialityEditModal = (props: ConfidentialityEditModalProps): JSX.Element => {
   return (
      <Modal testId={'confidentialityEdit'} title={t.modal.title} width={ModalWidth.NORMAL}>
         <ConfidentialityEditForm confidentialityConfiguration={props.confidentialityConfiguration}>
            {({ handleSubmit, isDirty }) => (
               <>
                  <ConfidentialityUpdateAction
                     confidentialityConfiguration={props.confidentialityConfiguration}
                     onSuccess={props.onClose}
                  >
                     {({ updateAccessDurations }) => (
                        <ModalConfirmButton
                           testId={'save'}
                           label={commonTranslationKeys.save}
                           onClick={handleSubmit(updateAccessDurations)}
                        />
                     )}
                  </ConfidentialityUpdateAction>
                  <ModalCancelButton
                     label={commonTranslationKeys.cancel}
                     onClick={props.onClose}
                     shouldConfirmExit={isDirty}
                  />
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={isDirty} />
               </>
            )}
         </ConfidentialityEditForm>
      </Modal>
   );
};
